export default {
    state:{ 
        searchVal: '', // 搜索词
        leftNavIndex:'',//左侧acvit状态 
        tabNav: [
            { val: '书目', num: 0, type: '1' },
            { val: '条目', num: 0, type: '2' }
        ],
    },
    mutations:{
        setSearchVal(state, val){
            state.searchVal = val;
        },
        // 更新 tabNav 的 num 值，type: '1' 书目，'2' 条目
        setTabNavNum(state, { type, num }){ 
            const item = state.tabNav.find(t => t.type === type);
            if(item){
                item.num = num;
            }
        },
        setLeftNavIndex(state, val){ 
            state.leftNavIndex = val;
        }
    },
    actions: {}, 
}